import {
  Layers,
  Radio,
  Clock,
  ShieldCheck,
  Smartphone,
  HeartHandshake,
} from "lucide-react";

const benefits = [
  {
    icon: Layers,
    title: "Une seule appli pour tout piloter",
    description:
      "Fini les outils séparés pour le planning, les stocks, la caisse et la conformité : tout est réuni dans Hygio, avec une seule connexion et une seule équipe à former.",
  },
  {
    icon: Radio,
    title: "Votre équipe suivie en temps réel",
    description:
      "Badgeage, présence, plannings : vous savez à tout instant qui est en poste, sans avoir à réclamer un rapport en fin de journée.",
  },
  {
    icon: Clock,
    title: "Des heures de paperasse en moins",
    description:
      "Relevés digitalisés, alertes automatiques, rapports générés seuls : votre équipe se concentre sur le métier, pas sur les registres papier.",
  },
  {
    icon: ShieldCheck,
    title: "Conforme, en toute simplicité",
    description:
      "Chaque relevé, chaque intervention est horodaté et archivé. Vos justificatifs HACCP sont prêts à être présentés à tout moment.",
  },
  {
    icon: Smartphone,
    title: "Une vraie appli, sans App Store",
    description:
      "Installable en un geste sur mobile, tablette ou ordinateur, avec notifications push pour ne rien manquer — en boutique, en cuisine ou en réserve.",
  },
  {
    icon: HeartHandshake,
    title: "La tranquillité d'esprit",
    description:
      "Une vue d'ensemble claire sur votre commerce, à tout moment, pour piloter sereinement au lieu de courir après l'information.",
  },
];

export default function Benefits() {
  return (
    <section id="pourquoi-hygio" className="bg-paper py-20 sm:py-28">
      <div className="mx-auto max-w-content px-5 sm:px-8">
        <div className="max-w-2xl">
          <h2 className="text-3xl font-semibold tracking-tight text-ink sm:text-4xl">
            Pourquoi les commerçants choisissent Hygio
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-ink-soft">
            Hygio a été conçu avec des gérants de boulangeries, restaurants et
            boutiques alimentaires pour remplacer plusieurs outils par un
            seul, simple et vraiment utile au quotidien.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-x-8 gap-y-10 sm:grid-cols-2 lg:grid-cols-3">
          {benefits.map(({ icon: Icon, title, description }) => (
            <div key={title} className="flex gap-4">
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-accent text-white">
                <Icon size={19} strokeWidth={2} />
              </div>
              <div>
                <h3 className="text-[16px] font-semibold text-ink">
                  {title}
                </h3>
                <p className="mt-1.5 text-[15px] leading-relaxed text-ink-soft">
                  {description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
